import * as React from "react";
import {RefObject} from "react";
import Label from "../Label";

class Echeck extends React.Component<any, any> {
  public getPaymentToken: Function = () => {};
  private getState: Function = () => {};
  private readonly baseInput: RefObject<HTMLInputElement>;

  constructor(props: any) {
    super(props);
    this.baseInput = React.createRef();
    this.state = {
      bank_account_number: '',
      bank_account_numberToken: '',
      routing_number: '',
      routing_numberToken: '',
      account_type: 'checking',
      showErrors: false
    }
  }

  public validate = () => {
    let state = this.getState();
    state.target = state.fields[0];
    this.onState(state);
    state.target = state.fields[1];
    this.onState(state);
  };

  private onState = (event: any) => {
    let target = event.target;
    let stateChange = {};
    stateChange[target.type] = target.error;
    stateChange[target.type + 'Token'] = target.token;
    // if (target.card) stateChange['card'] = target.card;
    this.setState(stateChange);
  };

  private getStyles = () => {
    let baseStyle = window.getComputedStyle(this.baseInput.current!);

    let clonedStyle = {
      'font-size': '16px',
      'color': baseStyle.color,
      'padding': baseStyle.padding,
      'border': baseStyle.border,
      'font-family': baseStyle.fontFamily,
      'font-weight': baseStyle.fontWeight,
      'border-radius': baseStyle.borderRadius,
      'width': baseStyle.width,
      'background': baseStyle.background,
      '-webkit-font-smoothing': baseStyle.getPropertyValue('-webkit-font-smoothing'),
      '::placeholder' : { color: '#999' }
    };

    return [
      {
        selector: `#bank_account_number${this.props.index}`,
        input: {
          placeholder: 'Bank Account Number',
          type: 'bank_account_number',
          css: clonedStyle
        }
      },
      {
        selector: `#routing_number${this.props.index}`,
        input: {
          type: 'routing_number',
          placeholder: 'Routing Number',
          css: clonedStyle
        }
      }
    ];
  };

  private initializeHostedFields = ()=> {
    ({
      getPaymentToken: this.getPaymentToken,
      getState: this.getState
    } = window['AffiniPay'].HostedFields.initializeFields({
      publicKey: this.props.publicKey,
      fields: this.getStyles()
    }, this.onState));
  };

  public componentDidMount() {
    this.initializeHostedFields();
  }

  public render() {
    return (
      <div>
        <div className="BankAccountNumber">
          <Label htmlFor="bank_account_number" showErrors={true} error={this.state.bank_account_number}>
            Bank Account Number
          </Label>

          <input className="hidden-input" tabIndex={-1} type="text" minLength={1}
                 ref={this.baseInput}
                 onInvalid={this.validate}
                 value={this.state.bank_account_numberToken}
                 onChange={()=>{}} required/>
          <div id={`bank_account_number${this.props.index}`} />
        </div>

        <Label htmlFor="routing_number" showErrors={true} error={this.state.routing_number}>
          Routing Number
        </Label>
        <input
          onInvalid={this.validate}
          className="hidden-input" tabIndex={-1} type="text" minLength={1} value={this.state.routing_numberToken}
          onChange={()=>{}} required/>
        <div id={`routing_number${this.props.index}`} className="HostedField"/>
      </div>
    );
  }
}

export default Echeck;


// WEBPACK FOOTER //
// ./src/checkout/fields/echeck/eCheck.tsx